export const hasEffect = (effectType) => (transaction) => transaction.effects.some((effect) => effect.is(effectType));

export const updateHasEffect = (effectType) => (update) =>
    update.transactions.some((transaction) => transaction.effects.some((effect) => effect.is(effectType)));
